import { afterNextRender, Component, inject, input, signal } from '@angular/core';
import { ProductsService } from '../../../product/products.service';
import { ProductCardV2Component } from '../../product-card-v2/product-card-v2.component';
import { SkeletonProductCardComponent } from '../../skeleton-product-card/skeleton-product-card.component';
import { PaymentMethodSignupService } from '../../../authentication/signup/payment-method-signup/payment-method-signup.service';
import { LocalStorageService } from '../../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../../constants/databases';
import { Session } from '../../types/session.type';
import { finalize, tap } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-farmbox-subscription',
  imports: [
    ProductCardV2Component,
    SkeletonProductCardComponent
  ],
  templateUrl: './farmbox-subscription.component.html',
  styleUrl: './farmbox-subscription.component.scss'
})
export class FarmboxSubscriptionComponent {

  //#region Services

  #productsService = inject(ProductsService);

  #paymentMethodSignupService = inject(PaymentMethodSignupService);

  #localStorageService = inject(LocalStorageService);

  #activeModal = inject(NgbActiveModal);

  //#endregion

  //#region I/O

  categoryId = input.required<number>();

  //#endregion

  //#region Properties

  products = signal<any[]>([]);

  isLoading = signal(true);

  //#endregion

  //#region Constructor

  constructor() {
    afterNextRender(() => this.#getBundleProducts());
  }

  //#endregion

  //#region Methods

  #getBundleProducts() {
    this.isLoading.set(true);

    this.#productsService
      .getProductsByCategory(this.categoryId(), true)
      .pipe(
        finalize(() => this.isLoading.set(false)),
        tap(resp => this.products.set(resp?.data?.products ?? []))
      )
      .subscribe();
  }

  subscribed() {
    const sessionData: Session | null = this.#localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
    if (!sessionData)
      return;

    if (sessionData.subscriptionRequirement)
      sessionData.subscriptionRequirement.subscriptionRequirementMet = true;

    this.#localStorageService.set(LOCALSTORAGE_KEYS.SESSION, sessionData);

    this.#activeModal.close();
  }

  //#endregion
}
